// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Запрет прокрутки body */
body.at-modal-open {
  overflow: hidden;
  position: fixed;
  width: 100%;
}

/* Основные стили */
.at-attendance-section {
  min-height: 50vh;
  background: white;
  font-family: 'Montserrat', sans-serif !important;
  color: #1f2937;
}

/* Загрузка */
.at-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 50vh;
  color: #002FA7;
}

.at-loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(0, 47, 167, 0.3);
  border-left: 4px solid #002FA7;
  border-radius: 50%;
  animation: at-spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes at-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.at-loading p {
  font-size: 18px;
  margin: 0;
}

/* Навигация */
.at-nav {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 30px;
}

.at-nav-btn {
  padding: 15px 30px;
  border: none;
  border-radius: 15px;
  background: rgba(0, 47, 167, 0.1);
  color: #002FA7;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1em;
  width: 30%;
}

.at-nav-btn:hover {
  background: rgba(0, 47, 167, 0.2);
  transform: translateY(-2px);
}

.at-nav-btn.at-active {
  background: #002FA7;
  color: white;
  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.3);
}

/* Кнопка обновления */
.at-refresh-btn {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
  color: #374151;
  padding: 12px 24px;
  border-radius: 16px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
}

.at-refresh-btn:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);
  color: #002FA7;
}

.at-refresh-btn:disabled {
  background: #f1f5f9;
  border-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.at-refresh-icon {
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease;
}

.at-refresh-spin {
  animation: at-spin 1s linear infinite;
}

/* Контролы */
.at-controls-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-bottom: 24px;
  margin-left: 34px;
  flex-wrap: wrap;
}

.at-controls-section-left {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-right: 34px;
  flex-wrap: wrap;
}

/* Селектор семестра */
.at-semester-selector {
  display: flex;
  gap: 10px;
}

.at-semester-buttons {
  display: flex;
  background: rgba(0, 47, 167, 0.1);
  border-radius: 15px;
  padding: 5px;
  gap: 5px;
}

.at-semester-btn {
  padding: 12px 20px;
  border: none;
  border-radius: 12px;
  background: transparent;
  color: #6c757d;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.at-semester-btn.at-active {
  background: white;
  color: #002FA7;
  box-shadow: 0 4px 15px rgba(0, 47, 167, 0.3);
}

/* Переключение вида */
.at-view-toggle {
  display: flex;
  background: rgba(0, 47, 167, 0.1);
  border-radius: 12px;
  padding: 4px;
  gap: 4px;
}

.at-toggle-btn {
  padding: 12px 20px;
  border: none;
  border-radius: 12px;
  background: transparent;
  color: #6c757d;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.at-toggle-btn.at-active {
  background: white;
  color: #002FA7;
  box-shadow: 0 2px 8px rgba(0, 47, 167, 0.2);
}

/* Статусная информация */
.at-status-info {
  margin-bottom: 20px;
}

.at-error-message {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  border: 1px solid #fca5a5;
  color: #dc2626;
  padding: 12px 16px;
  border-radius: 12px;
  font-weight: 500;
  border-left: 4px solid #ef4444;
}

.at-cache-warning {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border: 1px solid #f59e0b;
  color: #92400e;
  padding: 12px 16px;
  border-radius: 12px;
  font-weight: 500;
  border-left: 4px solid #f59e0b;
}

/* Основной контент */
.at-content {
  padding: 0 25px 25px;
}

.at-tab-content {
  animation: at-fadeIn 0.5s ease;
}

@keyframes at-fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Сетка предметов */
.at-subjects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 25px;
  margin-bottom: 40px;
}

.at-subject-card {
  background: white;
  border-radius: 20px;
  padding: 25px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 47, 167, 0.1);
}

.at-subject-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
  border-color: rgba(0, 47, 167, 0.3);
}

.at-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.at-subject-title {
  margin: 0;
  font-size: 1.3em;
  font-weight: 600;
  color: #2d3748;
  line-height: 1.3;
  text-align: left;
}

.at-teacher-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(0, 47, 167, 0.1);
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.85em;
  color: #002FA7;
  white-space: nowrap;
}

/* Превью посещаемости */
.at-attendance-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
  min-height: 40px;
  align-items: center;
}

.at-preview-status,
.at-stack-status,
.at-attendance-value {
  width: 35px;
  height: 35px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 0.9em;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.at-preview-status:hover,
.at-stack-status:hover,
.at-attendance-value:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  z-index: 1;
  position: relative;
}

/* Для неотмеченных статусов */
.at-stack-status[style*="background-color: #d1d5db"]:hover,
.at-preview-status[style*="background-color: #d1d5db"]:hover,
.at-attendance-value[style*="background-color: #d1d5db"]:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.at-more-statuses {
  background: #e2e8f0;
  color: #64748b;
  padding: 8px 12px;
  border-radius: 10px;
  font-size: 0.8em;
  font-weight: 500;
}

.at-no-statuses {
  color: #94a3b8;
  font-size: 0.9em;
  font-style: italic;
}

/* Футер карточки */
.at-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 15px;
  border-top: 1px solid #e2e8f0;
}

.at-percent-score {
  display: flex;
  align-items: center;
  gap: 8px;
}

.at-percent-label {
  font-size: 0.9em;
  color: #718096;
}

.at-percent-value {
  font-weight: 700;
  font-size: 1.1em;
}

/* Таблица предметов */
.at-subjects-table-container {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 47, 167, 0.1);
}

.at-subjects-table {
  width: 100%;
  border-collapse: collapse;
}

.at-subjects-table th {
  background: rgba(0, 47, 167, 0.05);
  padding: 20px;
  text-align: left;
  font-weight: 600;
  color: #4a5568;
  border-bottom: 1px solid #e2e8f0;
}

.at-subjects-table td {
  padding: 20px;
  border-bottom: 1px solid #f7fafc;
}

.at-subjects-table tr:hover {
  background: rgba(0, 47, 167, 0.02);
}

.at-subject-cell {
  width: 25%;
  text-align: left;
}

.at-subject-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.at-subject-name {
  font-weight: 600;
  color: #1e293b;
  font-size: 1rem;
}

.at-subject-teacher {
  font-size: 0.9rem;
  color: #64748b;
  font-weight: 500;
}

.at-attendance-cell {
  width: 45%;
}

.at-attendance-stack {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.at-absences-cell {
  width: 20%;
}

.at-absences-breakdown {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.at-absence-type {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9em;
}

.at-absence-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.at-absence-dot.at-excused {
  background-color: #f59e0b;
}

.at-absence-dot.at-sick {
  background-color: #6b7280;
}

.at-absence-dot.at-absent {
  background-color: #ef4444;
}

.at-absence-count {
  color: #4a5568;
  font-weight: 500;
}

.at-absence-total {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid #e2e8f0;
  font-weight: 500;
  font-size: 0.9em;
  color: #374151;
}

.at-percent-cell {
  width: 15%;
}

.at-percent-badge {
  padding: 8px 16px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.9em;
  text-align: center;
  min-width: 60px;
  display: inline-block;
}

/* Аналитика */
.at-analytics-container {
  background: white;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 47, 167, 0.1);
}

/* Карточки статистики */
.at-stats-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.at-stat-card {
  background: rgba(0, 47, 167, 0.08);
  color: #002FA7;
  padding: 25px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(0, 47, 167, 0.1);
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 47, 167, 0.1);
}

.at-stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.15);
  background: rgba(0, 47, 167, 0.12);
}

.at-stat-content {
  text-align: center;
}

.at-stat-content .at-stat-value {
  font-size: 2.5em;
  font-weight: 700;
  margin: 0;
  line-height: 1;
  color: #002FA7;
}

.at-stat-content .at-stat-label {
  font-size: 1em;
  color: #002FA7;
  margin: 8px 0 0 0;
  font-weight: 500;
  opacity: 0.9;
}

/* Графики */
.at-charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  gap: 30px;
}

.at-chart-card {
  background: white;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 47, 167, 0.1);
}

.at-chart-card.at-large {
  padding: 30px;
}

.at-chart-card h3 {
  margin: 0 0 25px 0;
  color: #2d3748;
  font-size: 1.3em;
  font-weight: 600;
  text-align: center;
}

.at-chart-header {
  margin-bottom: 20px;
}

/* Фильтр периодов */
.at-period-filter {
  margin-bottom: 20px;
}

.at-date-inputs {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.at-date-input {
  padding: 8px 12px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  min-width: 140px;
}

.at-date-input:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.at-date-separator {
  color: #718096;
  font-weight: 500;
}

.at-apply-filter-btn {
  padding: 8px 16px;
  background: #002FA7;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.at-apply-filter-btn:hover {
  background: #1e40af;
  transform: translateY(-1px);
}

.at-reset-filter-btn {
  padding: 8px 16px;
  background: #c7cad1;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.at-reset-filter-btn:hover {
  background: rgb(142, 146, 152);
  transform: translateY(-1px);
}

/* Детали предмета */
.at-subject-detail-container {
  background: white;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 47, 167, 0.1);
}

.at-subject-selector {
  margin-bottom: 30px;
}

.at-select {
  width: 100%;
  padding: 15px 20px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1em;
  background: white;
  color: #4a5568;
  cursor: pointer;
  transition: all 0.3s ease;
}

.at-select:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.at-detail-header {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f7fafc;
}

.at-detail-header h2 {
  margin: 0 0 15px 0;
  color: #2d3748;
  font-size: 1.8em;
  font-weight: 700;
}

.at-subject-meta {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.at-meta-item {
  background: rgba(0, 47, 167, 0.1);
  color: #002FA7;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.9em;
  font-weight: 500;
}

/* Таймлайн посещаемости */
.at-attendance-timeline {
  position: relative;
  padding-left: 30px;
}

.at-attendance-timeline::before {
  content: '';
  position: absolute;
  left: 15px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #e2e8f0;
}

.at-timeline-item {
  position: relative;
  margin-bottom: 25px;
}

.at-timeline-content {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #f1f5f9;
}

.at-attendance-details {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  margin-bottom: 10px;
}

.at-attendance-date {
  color: #718096;
  font-size: 0.9em;
  background: #f7fafc;
  padding: 4px 10px;
  border-radius: 8px;
}

/* Состояние без выбранного предмета */
.at-no-subject-selected,
.at-no-data-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  width: 100%;
}

.at-empty-state {
  text-align: center;
  padding: 2rem;
  max-width: 400px;
}

.at-empty-state h3 {
  color: #64748b;
  margin-bottom: 0.5rem;
}

.at-empty-state p {
  color: #94a3b8;
  margin-bottom: 1rem;
  font-size: 1.1em;
}

/* Попап */
.at-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(50, 64, 124, 0.3);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: at-fadeIn 0.2s ease;
}

.at-popup {
  background: white;
  border-radius: 16px;
  padding: 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  max-width: 420px;
  width: 90%;
  animation: at-modal-fade-in 0.3s ease;
  border: 1px solid #e2e8f0;
}

.at-popup-large {
  max-width: 800px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  animation: at-scaleIn 0.3s ease;
}

@keyframes at-modal-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes at-scaleIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}

.at-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #f1f5f9;
}

.at-popup-header h3 {
  margin: 0;
  color: #002FA7;
  font-size: 1.5rem;
  font-weight: 600;
}

.at-popup-close {
  background: rgba(0, 47, 167, 0.1);
  border: none;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #002FA7;
  font-size: 28px;
  font-weight: 300;
}

.at-popup-close:hover {
  background: rgba(0, 47, 167, 0.2);
}

.at-popup-content {
  padding: 30px 40px;
  overflow-y: auto;
}

/* Детальная информация в попапе */
.at-attendance-info-detailed {
  padding: 0;
}

.at-attendance-main-info {
  display: flex;
  align-items: flex-start;
  gap: 30px;
  padding: 30px;
  background: linear-gradient(135deg, rgba(0, 47, 167, 0.03) 0%, rgba(255, 255, 255, 0.8) 100%);
  border-radius: 20px;
  border: 1px solid rgba(0, 47, 167, 0.1);
}

.at-status-circle-large {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 4px solid;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
}

.at-status-symbol-large {
  font-size: 2.5rem;
  font-weight: 800;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.at-attendance-basic-details {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.at-detail-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0;
}

.at-detail-label {
  font-size: 0.85rem;
  color: #718096;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.at-detail-value {
  font-size: 1.1rem;
  color: #011f6d;
  font-weight: 600;
}

.at-detail-value.at-status-text {
  font-weight: 600;
  text-transform: uppercase;
  color: #002FA7;
}

.at-detail-value.at-teacher {
  color: #002FA7;
  font-weight: 600;
}

/* Причина пропуска */
.at-reason-item {
  margin-top: 10px;
  padding-top: 20px;
  border-top: 2px solid rgba(0, 47, 167, 0.1);
}

.at-reason-content {
  margin-top: 8px;
}

.at-detail-value.at-reason-text {
  background: rgba(245, 158, 11, 0.1);
  padding: 16px 20px;
  border-radius: 12px;
  border-left: 4px solid #f59e0b;
  font-weight: 500;
  line-height: 1.5;
  color: #92400e;
  font-size: 1rem;
}

.at-detail-value.at-no-reason,
.at-detail-value.at-no-status-text {
  background: rgba(107, 114, 128, 0.1);
  padding: 16px 20px;
  border-radius: 12px;
  border-left: 4px solid #6b7280;
  font-weight: 500;
  line-height: 1.5;
  color: #6b7280;
  font-style: italic;
  font-size: 1rem;
}

.at-no-status-info {
  margin-top: 10px;
  padding-top: 20px;
  border-top: 2px solid rgba(0, 47, 167, 0.1);
}

/* Состояния загрузки */
.at-loading-small {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: #718096;
  text-align: center;
}

.at-loading-small .at-loading-spinner {
  width: 30px;
  height: 30px;
  border: 3px solid rgba(0, 47, 167, 0.2);
  border-left: 3px solid #002FA7;
  border-radius: 50%;
  animation: at-spin 1s linear infinite;
  margin-bottom: 10px;
}

.at-loading-small p {
  font-size: 0.9rem;
  margin: 0;
}

/* Недостаточно данных */
.at-insufficient-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  text-align: center;
  padding: 40px 20px;
  color: #6b7280;
}

.at-insufficient-data h4 {
  margin: 0 0 10px 0;
  color: #868b95;
  font-size: 1.3rem;
  font-weight: 600;
}

.at-data-warning-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

/* Адаптивность */
@media (max-width: 768px) {
  .at-nav {
    flex-direction: column;
    padding: 0 20px;
  }
  
  .at-nav-btn {
    width: 100%;
  }
  
  .at-content {
    padding: 0 20px 20px;
  }
  
  .at-controls-section {
    flex-direction: column;
    gap: 15px;
    padding: 0 20px;
    margin-left: 0;
  }
  
  .at-controls-section-left {
    margin-right: 0;
    width: 100%;
    justify-content: center;
  }
  
  .at-subjects-grid {
    grid-template-columns: 1fr;
  }
  
  .at-charts-grid {
    grid-template-columns: 1fr;
  }
  
  .at-chart-card.at-large {
    padding: 20px;
  }
  
  .at-stats-cards {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .at-popup-content {
    padding: 20px;
  }
  
  .at-attendance-main-info {
    flex-direction: column;
    text-align: center;
    gap: 25px;
    padding: 20px;
  }
  
  .at-status-circle-large {
    align-self: center;
  }
  
  .at-attendance-basic-details {
    text-align: left;
  }
  
  .at-date-inputs {
    flex-direction: column;
    align-items: stretch;
  }
  
  .at-date-input {
    min-width: auto;
  }
  
  .at-apply-filter-btn,
  .at-reset-filter-btn {
    flex: 1 1;
  }
}

@media (max-width: 480px) {
  .at-stats-cards {
    grid-template-columns: 1fr;
  }
  
  .at-subject-meta {
    flex-direction: column;
    gap: 10px;
  }
  
  .at-semester-buttons {
    flex-direction: column;
  }
  
  .at-popup {
    max-width: 95%;
  }
}







/* Кнопка для старосты */
.at-headman-btn {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
  color: #374151;
  padding: 14px 20px;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
}

.at-headman-btn:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);
}

.at-headman-btn:active {
  transform: translateY(0);
}

/* Адаптивность для мобильных */
@media (max-width: 768px) {
  .at-headman-btn span {
    display: none;
  }
  
  .at-headman-btn {
    padding: 8px;
  }
  
  .at-headman-icon {
    width: 20px;
    height: 20px;
  }
}



/* ===== ОБНОВЛЕННЫЕ СТИЛИ ДЛЯ ДЕТАЛЬНОЙ ИНФОРМАЦИИ О ПРЕДМЕТЕ ===== */

.at-attendance-timeline {
  margin-top: 30px;
}

/* Сетка для отображения статусов */
.at-attendance-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 16px;
  padding: 20px;
  background: #f8fafc;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
}

/* Карточка каждого занятия */
.at-attendance-grid-item {
  background: white;
  border-radius: 16px;
  padding: 16px 12px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid #f1f5f9;
  position: relative;
}

.at-attendance-grid-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  border-color: rgba(0, 47, 167, 0.2);
}

/* Кружок со статусом */
.at-attendance-grid-status {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  transition: transform 0.2s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.at-attendance-grid-item:hover .at-attendance-grid-status {
  transform: scale(1.05);
}

.at-status-letter {
  font-size: 28px;
  font-weight: 800;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  text-transform: uppercase;
}

/* Дата занятия */
.at-attendance-grid-date {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
  margin-top: 8px;
  word-break: break-word;
}

/* Иконка комментария */
.at-attendance-grid-comment {
  position: absolute;
  top: 4px;
  right: 8px;
  font-size: 24px;
  opacity: 0.7;
  transition: opacity 0.2s ease;
  color: #f59e0b;
  font-weight: 500;

}

.at-attendance-grid-comment:hover {
  opacity: 1;
}

/* Адаптивность для мобильных */
@media (max-width: 768px) {
  .at-attendance-grid {
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    gap: 12px;
    padding: 16px;
  }
  
  .at-attendance-grid-status {
    width: 50px;
    height: 50px;
  }
  
  .at-status-letter {
    font-size: 22px;
  }
  
  .at-attendance-grid-date {
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .at-attendance-grid {
    grid-template-columns: repeat(auto-fill, minmax(70px, 1fr));
    gap: 10px;
    padding: 12px;
  }
  
  .at-attendance-grid-status {
    width: 45px;
    height: 45px;
  }
  
  .at-status-letter {
    font-size: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/st-components/AttendanceSectionStyle.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gDAAgD;EAChD,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,8BAA8B;EAC9B,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA,cAAc;AACd;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA,sBAAsB;AACtB;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;;;EAGE,qBAAqB;EACrB,yCAAyC;EACzC,UAAU;EACV,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;;;EAGE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,yCAAyC;EACzC,gBAAgB;EAChB,UAAU;EACV,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,qBAAqB,EAAE;EAC1C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,6FAA6F;EAC7F,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,8BAA8B;EAC9B,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,SAAO;EACT;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;AACF;;;;;;;;AAQA,wBAAwB;AACxB;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,+BAA+B;AAC/B;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;;;AAIA,sEAAsE;;AAEtE;EACE,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;;AAElB;;AAEA;EACE,UAAU;AACZ;;AAEA,+BAA+B;AAC/B;EACE;IACE,2DAA2D;IAC3D,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,2DAA2D;IAC3D,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Запрет прокрутки body */\nbody.at-modal-open {\n  overflow: hidden;\n  position: fixed;\n  width: 100%;\n}\n\n/* Основные стили */\n.at-attendance-section {\n  min-height: 50vh;\n  background: white;\n  font-family: 'Montserrat', sans-serif !important;\n  color: #1f2937;\n}\n\n/* Загрузка */\n.at-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 50vh;\n  color: #002FA7;\n}\n\n.at-loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid rgba(0, 47, 167, 0.3);\n  border-left: 4px solid #002FA7;\n  border-radius: 50%;\n  animation: at-spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes at-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.at-loading p {\n  font-size: 18px;\n  margin: 0;\n}\n\n/* Навигация */\n.at-nav {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 30px;\n}\n\n.at-nav-btn {\n  padding: 15px 30px;\n  border: none;\n  border-radius: 15px;\n  background: rgba(0, 47, 167, 0.1);\n  color: #002FA7;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 1em;\n  width: 30%;\n}\n\n.at-nav-btn:hover {\n  background: rgba(0, 47, 167, 0.2);\n  transform: translateY(-2px);\n}\n\n.at-nav-btn.at-active {\n  background: #002FA7;\n  color: white;\n  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.3);\n}\n\n/* Кнопка обновления */\n.at-refresh-btn {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border: 1px solid #e2e8f0;\n  color: #374151;\n  padding: 12px 24px;\n  border-radius: 16px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  white-space: nowrap;\n}\n\n.at-refresh-btn:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);\n  color: #002FA7;\n}\n\n.at-refresh-btn:disabled {\n  background: #f1f5f9;\n  border-color: #d1d5db;\n  color: #9ca3af;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.at-refresh-icon {\n  width: 24px;\n  height: 24px;\n  transition: transform 0.3s ease;\n}\n\n.at-refresh-spin {\n  animation: at-spin 1s linear infinite;\n}\n\n/* Контролы */\n.at-controls-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 24px;\n  margin-left: 34px;\n  flex-wrap: wrap;\n}\n\n.at-controls-section-left {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  margin-right: 34px;\n  flex-wrap: wrap;\n}\n\n/* Селектор семестра */\n.at-semester-selector {\n  display: flex;\n  gap: 10px;\n}\n\n.at-semester-buttons {\n  display: flex;\n  background: rgba(0, 47, 167, 0.1);\n  border-radius: 15px;\n  padding: 5px;\n  gap: 5px;\n}\n\n.at-semester-btn {\n  padding: 12px 20px;\n  border: none;\n  border-radius: 12px;\n  background: transparent;\n  color: #6c757d;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.at-semester-btn.at-active {\n  background: white;\n  color: #002FA7;\n  box-shadow: 0 4px 15px rgba(0, 47, 167, 0.3);\n}\n\n/* Переключение вида */\n.at-view-toggle {\n  display: flex;\n  background: rgba(0, 47, 167, 0.1);\n  border-radius: 12px;\n  padding: 4px;\n  gap: 4px;\n}\n\n.at-toggle-btn {\n  padding: 12px 20px;\n  border: none;\n  border-radius: 12px;\n  background: transparent;\n  color: #6c757d;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.at-toggle-btn.at-active {\n  background: white;\n  color: #002FA7;\n  box-shadow: 0 2px 8px rgba(0, 47, 167, 0.2);\n}\n\n/* Статусная информация */\n.at-status-info {\n  margin-bottom: 20px;\n}\n\n.at-error-message {\n  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n  border: 1px solid #fca5a5;\n  color: #dc2626;\n  padding: 12px 16px;\n  border-radius: 12px;\n  font-weight: 500;\n  border-left: 4px solid #ef4444;\n}\n\n.at-cache-warning {\n  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);\n  border: 1px solid #f59e0b;\n  color: #92400e;\n  padding: 12px 16px;\n  border-radius: 12px;\n  font-weight: 500;\n  border-left: 4px solid #f59e0b;\n}\n\n/* Основной контент */\n.at-content {\n  padding: 0 25px 25px;\n}\n\n.at-tab-content {\n  animation: at-fadeIn 0.5s ease;\n}\n\n@keyframes at-fadeIn {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* Сетка предметов */\n.at-subjects-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 25px;\n  margin-bottom: 40px;\n}\n\n.at-subject-card {\n  background: white;\n  border-radius: 20px;\n  padding: 25px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  border: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.at-subject-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);\n  border-color: rgba(0, 47, 167, 0.3);\n}\n\n.at-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 20px;\n}\n\n.at-subject-title {\n  margin: 0;\n  font-size: 1.3em;\n  font-weight: 600;\n  color: #2d3748;\n  line-height: 1.3;\n  text-align: left;\n}\n\n.at-teacher-badge {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: rgba(0, 47, 167, 0.1);\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 0.85em;\n  color: #002FA7;\n  white-space: nowrap;\n}\n\n/* Превью посещаемости */\n.at-attendance-preview {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 20px;\n  min-height: 40px;\n  align-items: center;\n}\n\n.at-preview-status,\n.at-stack-status,\n.at-attendance-value {\n  width: 35px;\n  height: 35px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 600;\n  font-size: 0.9em;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.at-preview-status:hover,\n.at-stack-status:hover,\n.at-attendance-value:hover {\n  transform: scale(1.1);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n  position: relative;\n}\n\n/* Для неотмеченных статусов */\n.at-stack-status[style*=\"background-color: #d1d5db\"]:hover,\n.at-preview-status[style*=\"background-color: #d1d5db\"]:hover,\n.at-attendance-value[style*=\"background-color: #d1d5db\"]:hover {\n  transform: scale(1.05);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.at-more-statuses {\n  background: #e2e8f0;\n  color: #64748b;\n  padding: 8px 12px;\n  border-radius: 10px;\n  font-size: 0.8em;\n  font-weight: 500;\n}\n\n.at-no-statuses {\n  color: #94a3b8;\n  font-size: 0.9em;\n  font-style: italic;\n}\n\n/* Футер карточки */\n.at-card-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 15px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.at-percent-score {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.at-percent-label {\n  font-size: 0.9em;\n  color: #718096;\n}\n\n.at-percent-value {\n  font-weight: 700;\n  font-size: 1.1em;\n}\n\n/* Таблица предметов */\n.at-subjects-table-container {\n  background: white;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.at-subjects-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.at-subjects-table th {\n  background: rgba(0, 47, 167, 0.05);\n  padding: 20px;\n  text-align: left;\n  font-weight: 600;\n  color: #4a5568;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.at-subjects-table td {\n  padding: 20px;\n  border-bottom: 1px solid #f7fafc;\n}\n\n.at-subjects-table tr:hover {\n  background: rgba(0, 47, 167, 0.02);\n}\n\n.at-subject-cell {\n  width: 25%;\n  text-align: left;\n}\n\n.at-subject-info {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.at-subject-name {\n  font-weight: 600;\n  color: #1e293b;\n  font-size: 1rem;\n}\n\n.at-subject-teacher {\n  font-size: 0.9rem;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.at-attendance-cell {\n  width: 45%;\n}\n\n.at-attendance-stack {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.at-absences-cell {\n  width: 20%;\n}\n\n.at-absences-breakdown {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.at-absence-type {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.9em;\n}\n\n.at-absence-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.at-absence-dot.at-excused {\n  background-color: #f59e0b;\n}\n\n.at-absence-dot.at-sick {\n  background-color: #6b7280;\n}\n\n.at-absence-dot.at-absent {\n  background-color: #ef4444;\n}\n\n.at-absence-count {\n  color: #4a5568;\n  font-weight: 500;\n}\n\n.at-absence-total {\n  margin-top: 6px;\n  padding-top: 6px;\n  border-top: 1px solid #e2e8f0;\n  font-weight: 500;\n  font-size: 0.9em;\n  color: #374151;\n}\n\n.at-percent-cell {\n  width: 15%;\n}\n\n.at-percent-badge {\n  padding: 8px 16px;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 0.9em;\n  text-align: center;\n  min-width: 60px;\n  display: inline-block;\n}\n\n/* Аналитика */\n.at-analytics-container {\n  background: white;\n  border-radius: 20px;\n  padding: 30px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n/* Карточки статистики */\n.at-stats-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 40px;\n}\n\n.at-stat-card {\n  background: rgba(0, 47, 167, 0.08);\n  color: #002FA7;\n  padding: 25px;\n  border-radius: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 15px rgba(0, 47, 167, 0.1);\n  transition: all 0.3s ease;\n  border: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.at-stat-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.15);\n  background: rgba(0, 47, 167, 0.12);\n}\n\n.at-stat-content {\n  text-align: center;\n}\n\n.at-stat-content .at-stat-value {\n  font-size: 2.5em;\n  font-weight: 700;\n  margin: 0;\n  line-height: 1;\n  color: #002FA7;\n}\n\n.at-stat-content .at-stat-label {\n  font-size: 1em;\n  color: #002FA7;\n  margin: 8px 0 0 0;\n  font-weight: 500;\n  opacity: 0.9;\n}\n\n/* Графики */\n.at-charts-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));\n  gap: 30px;\n}\n\n.at-chart-card {\n  background: white;\n  padding: 30px;\n  border-radius: 15px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  border: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.at-chart-card.at-large {\n  padding: 30px;\n}\n\n.at-chart-card h3 {\n  margin: 0 0 25px 0;\n  color: #2d3748;\n  font-size: 1.3em;\n  font-weight: 600;\n  text-align: center;\n}\n\n.at-chart-header {\n  margin-bottom: 20px;\n}\n\n/* Фильтр периодов */\n.at-period-filter {\n  margin-bottom: 20px;\n}\n\n.at-date-inputs {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.at-date-input {\n  padding: 8px 12px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n  min-width: 140px;\n}\n\n.at-date-input:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.at-date-separator {\n  color: #718096;\n  font-weight: 500;\n}\n\n.at-apply-filter-btn {\n  padding: 8px 16px;\n  background: #002FA7;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.at-apply-filter-btn:hover {\n  background: #1e40af;\n  transform: translateY(-1px);\n}\n\n.at-reset-filter-btn {\n  padding: 8px 16px;\n  background: #c7cad1;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.at-reset-filter-btn:hover {\n  background: rgb(142, 146, 152);\n  transform: translateY(-1px);\n}\n\n/* Детали предмета */\n.at-subject-detail-container {\n  background: white;\n  border-radius: 20px;\n  padding: 30px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.at-subject-selector {\n  margin-bottom: 30px;\n}\n\n.at-select {\n  width: 100%;\n  padding: 15px 20px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1em;\n  background: white;\n  color: #4a5568;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.at-select:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.at-detail-header {\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #f7fafc;\n}\n\n.at-detail-header h2 {\n  margin: 0 0 15px 0;\n  color: #2d3748;\n  font-size: 1.8em;\n  font-weight: 700;\n}\n\n.at-subject-meta {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.at-meta-item {\n  background: rgba(0, 47, 167, 0.1);\n  color: #002FA7;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 0.9em;\n  font-weight: 500;\n}\n\n/* Таймлайн посещаемости */\n.at-attendance-timeline {\n  position: relative;\n  padding-left: 30px;\n}\n\n.at-attendance-timeline::before {\n  content: '';\n  position: absolute;\n  left: 15px;\n  top: 0;\n  bottom: 0;\n  width: 2px;\n  background: #e2e8f0;\n}\n\n.at-timeline-item {\n  position: relative;\n  margin-bottom: 25px;\n}\n\n.at-timeline-content {\n  background: white;\n  padding: 20px;\n  border-radius: 12px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n  border: 1px solid #f1f5f9;\n}\n\n.at-attendance-details {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.at-attendance-date {\n  color: #718096;\n  font-size: 0.9em;\n  background: #f7fafc;\n  padding: 4px 10px;\n  border-radius: 8px;\n}\n\n/* Состояние без выбранного предмета */\n.at-no-subject-selected,\n.at-no-data-state {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  width: 100%;\n}\n\n.at-empty-state {\n  text-align: center;\n  padding: 2rem;\n  max-width: 400px;\n}\n\n.at-empty-state h3 {\n  color: #64748b;\n  margin-bottom: 0.5rem;\n}\n\n.at-empty-state p {\n  color: #94a3b8;\n  margin-bottom: 1rem;\n  font-size: 1.1em;\n}\n\n/* Попап */\n.at-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(50, 64, 124, 0.3);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  animation: at-fadeIn 0.2s ease;\n}\n\n.at-popup {\n  background: white;\n  border-radius: 16px;\n  padding: 0;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  max-width: 420px;\n  width: 90%;\n  animation: at-modal-fade-in 0.3s ease;\n  border: 1px solid #e2e8f0;\n}\n\n.at-popup-large {\n  max-width: 800px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  animation: at-scaleIn 0.3s ease;\n}\n\n@keyframes at-modal-fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes at-scaleIn {\n  from { opacity: 0; transform: scale(0.9); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n.at-popup-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.at-popup-header h3 {\n  margin: 0;\n  color: #002FA7;\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.at-popup-close {\n  background: rgba(0, 47, 167, 0.1);\n  border: none;\n  border-radius: 50%;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: #002FA7;\n  font-size: 28px;\n  font-weight: 300;\n}\n\n.at-popup-close:hover {\n  background: rgba(0, 47, 167, 0.2);\n}\n\n.at-popup-content {\n  padding: 30px 40px;\n  overflow-y: auto;\n}\n\n/* Детальная информация в попапе */\n.at-attendance-info-detailed {\n  padding: 0;\n}\n\n.at-attendance-main-info {\n  display: flex;\n  align-items: flex-start;\n  gap: 30px;\n  padding: 30px;\n  background: linear-gradient(135deg, rgba(0, 47, 167, 0.03) 0%, rgba(255, 255, 255, 0.8) 100%);\n  border-radius: 20px;\n  border: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.at-status-circle-large {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 4px solid;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n  flex-shrink: 0;\n}\n\n.at-status-symbol-large {\n  font-size: 2.5rem;\n  font-weight: 800;\n  color: white;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.at-attendance-basic-details {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.at-detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 0;\n}\n\n.at-detail-label {\n  font-size: 0.85rem;\n  color: #718096;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.at-detail-value {\n  font-size: 1.1rem;\n  color: #011f6d;\n  font-weight: 600;\n}\n\n.at-detail-value.at-status-text {\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #002FA7;\n}\n\n.at-detail-value.at-teacher {\n  color: #002FA7;\n  font-weight: 600;\n}\n\n/* Причина пропуска */\n.at-reason-item {\n  margin-top: 10px;\n  padding-top: 20px;\n  border-top: 2px solid rgba(0, 47, 167, 0.1);\n}\n\n.at-reason-content {\n  margin-top: 8px;\n}\n\n.at-detail-value.at-reason-text {\n  background: rgba(245, 158, 11, 0.1);\n  padding: 16px 20px;\n  border-radius: 12px;\n  border-left: 4px solid #f59e0b;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #92400e;\n  font-size: 1rem;\n}\n\n.at-detail-value.at-no-reason,\n.at-detail-value.at-no-status-text {\n  background: rgba(107, 114, 128, 0.1);\n  padding: 16px 20px;\n  border-radius: 12px;\n  border-left: 4px solid #6b7280;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #6b7280;\n  font-style: italic;\n  font-size: 1rem;\n}\n\n.at-no-status-info {\n  margin-top: 10px;\n  padding-top: 20px;\n  border-top: 2px solid rgba(0, 47, 167, 0.1);\n}\n\n/* Состояния загрузки */\n.at-loading-small {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  color: #718096;\n  text-align: center;\n}\n\n.at-loading-small .at-loading-spinner {\n  width: 30px;\n  height: 30px;\n  border: 3px solid rgba(0, 47, 167, 0.2);\n  border-left: 3px solid #002FA7;\n  border-radius: 50%;\n  animation: at-spin 1s linear infinite;\n  margin-bottom: 10px;\n}\n\n.at-loading-small p {\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n/* Недостаточно данных */\n.at-insufficient-data {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 300px;\n  text-align: center;\n  padding: 40px 20px;\n  color: #6b7280;\n}\n\n.at-insufficient-data h4 {\n  margin: 0 0 10px 0;\n  color: #868b95;\n  font-size: 1.3rem;\n  font-weight: 600;\n}\n\n.at-data-warning-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .at-nav {\n    flex-direction: column;\n    padding: 0 20px;\n  }\n  \n  .at-nav-btn {\n    width: 100%;\n  }\n  \n  .at-content {\n    padding: 0 20px 20px;\n  }\n  \n  .at-controls-section {\n    flex-direction: column;\n    gap: 15px;\n    padding: 0 20px;\n    margin-left: 0;\n  }\n  \n  .at-controls-section-left {\n    margin-right: 0;\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .at-subjects-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .at-charts-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .at-chart-card.at-large {\n    padding: 20px;\n  }\n  \n  .at-stats-cards {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .at-popup-content {\n    padding: 20px;\n  }\n  \n  .at-attendance-main-info {\n    flex-direction: column;\n    text-align: center;\n    gap: 25px;\n    padding: 20px;\n  }\n  \n  .at-status-circle-large {\n    align-self: center;\n  }\n  \n  .at-attendance-basic-details {\n    text-align: left;\n  }\n  \n  .at-date-inputs {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .at-date-input {\n    min-width: auto;\n  }\n  \n  .at-apply-filter-btn,\n  .at-reset-filter-btn {\n    flex: 1;\n  }\n}\n\n@media (max-width: 480px) {\n  .at-stats-cards {\n    grid-template-columns: 1fr;\n  }\n  \n  .at-subject-meta {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .at-semester-buttons {\n    flex-direction: column;\n  }\n  \n  .at-popup {\n    max-width: 95%;\n  }\n}\n\n\n\n\n\n\n\n/* Кнопка для старосты */\n.at-headman-btn {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border: 1px solid #e2e8f0;\n  color: #374151;\n  padding: 14px 20px;\n  border-radius: 12px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  white-space: nowrap;\n}\n\n.at-headman-btn:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);\n}\n\n.at-headman-btn:active {\n  transform: translateY(0);\n}\n\n/* Адаптивность для мобильных */\n@media (max-width: 768px) {\n  .at-headman-btn span {\n    display: none;\n  }\n  \n  .at-headman-btn {\n    padding: 8px;\n  }\n  \n  .at-headman-icon {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n\n\n/* ===== ОБНОВЛЕННЫЕ СТИЛИ ДЛЯ ДЕТАЛЬНОЙ ИНФОРМАЦИИ О ПРЕДМЕТЕ ===== */\n\n.at-attendance-timeline {\n  margin-top: 30px;\n}\n\n/* Сетка для отображения статусов */\n.at-attendance-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n  gap: 16px;\n  padding: 20px;\n  background: #f8fafc;\n  border-radius: 20px;\n  border: 1px solid #e2e8f0;\n}\n\n/* Карточка каждого занятия */\n.at-attendance-grid-item {\n  background: white;\n  border-radius: 16px;\n  padding: 16px 12px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid #f1f5f9;\n  position: relative;\n}\n\n.at-attendance-grid-item:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n  border-color: rgba(0, 47, 167, 0.2);\n}\n\n/* Кружок со статусом */\n.at-attendance-grid-status {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 12px;\n  transition: transform 0.2s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.at-attendance-grid-item:hover .at-attendance-grid-status {\n  transform: scale(1.05);\n}\n\n.at-status-letter {\n  font-size: 28px;\n  font-weight: 800;\n  color: white;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  text-transform: uppercase;\n}\n\n/* Дата занятия */\n.at-attendance-grid-date {\n  font-size: 13px;\n  color: #64748b;\n  font-weight: 500;\n  margin-top: 8px;\n  word-break: break-word;\n}\n\n/* Иконка комментария */\n.at-attendance-grid-comment {\n  position: absolute;\n  top: 4px;\n  right: 8px;\n  font-size: 24px;\n  opacity: 0.7;\n  transition: opacity 0.2s ease;\n  color: #f59e0b;\n  font-weight: 500;\n\n}\n\n.at-attendance-grid-comment:hover {\n  opacity: 1;\n}\n\n/* Адаптивность для мобильных */\n@media (max-width: 768px) {\n  .at-attendance-grid {\n    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\n    gap: 12px;\n    padding: 16px;\n  }\n  \n  .at-attendance-grid-status {\n    width: 50px;\n    height: 50px;\n  }\n  \n  .at-status-letter {\n    font-size: 22px;\n  }\n  \n  .at-attendance-grid-date {\n    font-size: 11px;\n  }\n}\n\n@media (max-width: 480px) {\n  .at-attendance-grid {\n    grid-template-columns: repeat(auto-fill, minmax(70px, 1fr));\n    gap: 10px;\n    padding: 12px;\n  }\n  \n  .at-attendance-grid-status {\n    width: 45px;\n    height: 45px;\n  }\n  \n  .at-status-letter {\n    font-size: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
